import React, {useState} from 'react';
import {Link} from "react-scroll";
import '@components/module-components/menu/menu.scss';
import {useSelector} from 'react-redux';
import {translate} from '@src/helpers';
import {Translations} from '@constants/translate';

const Menu = ({isShowEco = 0}: any) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  const [isOpen, setOpen] = useState(false);
  const handleToggle = () => {
    if(!isOpen) {
      document.addEventListener('click', outsideClickListener);
    } else {
      document.removeEventListener('click', outsideClickListener);
    }
    setOpen(!isOpen);
  }

  const outsideClickListener = (event:any) => {
    const classList = Object.values(event.target.classList);
    const isClickOut = classList.find((item: any) => ['nav-block_list', 'nav-block_item'].includes(item));
    if(!isClickOut) {
      document.removeEventListener('click', outsideClickListener);
      setOpen(false);
    }
  }

  return (
    <nav className={`nav-block${isOpen ? ' open' : ''}`} >
      <button className="nav-block_btn" onClick={handleToggle}>
        { isOpen ?
          <svg xmlns="http://www.w3.org/2000/svg" width="18.414" height="18.414" viewBox="0 0 18.414 18.414">
            <g id="prefix__Group_351" data-name="Group 351" transform="translate(-1.893 4.092)">
                <g id="prefix__Group_198" data-name="Group 198" transform="translate(3 -1)">
                    <path id="prefix__Line_11" d="M17 0L0 17" className="prefix__cls-close" data-name="Line 11" transform="translate(-.4 -2.385)"/>
                    <path id="prefix__Line_12" d="M0 0L17 17" className="prefix__cls-close" data-name="Line 12" transform="translate(-.399 -2.385)"/>
                </g>
            </g>
          </svg> :
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18">
           <g id="prefix__Group_28" data-name="Group 28" transform="translate(-356 -15)">
               <path id="prefix__Path" d="M0 1h23" className="prefix__cls-open" transform="translate(356 31)"/>
               <path id="prefix__Path-2" d="M0 1h23" className="prefix__cls-open" data-name="Path" transform="translate(356 15)"/>
               <path id="prefix__Path-3" d="M0 1h23" className="prefix__cls-open" data-name="Path" transform="translate(356 23)"/>
           </g>
         </svg>
        }
      </button>
      <ul className="nav-block_list blist">
        <li className="nav-block_item blist_item"><Link to="product" spy={true} smooth={true} offset={-60} duration={500} className="blist_link">{translate(langData.localize, Translations['B2C.NAV.PRODUCT_VERIFICATION'])}</Link></li>
        { isShowEco === 1 && <li className="nav-block_item blist_item"><Link to="eco-score" spy={true} smooth={true} offset={-60} duration={500} className="blist_link">{translate(langData.localize, Translations['B2C.NAV.ECO_SCORE'])}</Link></li>}
        <li className="nav-block_item blist_item"><Link to="journey" spy={true} smooth={true} offset={-60} duration={500} className="blist_link">{translate(langData.localize, Translations['B2C.NAV.PRODUCT_JOURNEY'])}</Link></li>
      </ul>
    </nav>
  );
}

export default Menu;
